module.exports = __webpack_public_path__ + "media/1.a0bb88c7.mp4";